exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".router-link-active[data-v-7c88a56f]{font-weight:900;text-decoration:underline}.fadedMenu[data-v-7c88a56f]{font-weight:400;color:#dbdbdb;cursor:not-allowed}", ""]);

// exports
